import { render, staticRenderFns } from "./DeleteApiKeysButton.vue?vue&type=template&id=1c7dd54c&scoped=true"
import script from "./DeleteApiKeysButton.vue?vue&type=script&lang=js"
export * from "./DeleteApiKeysButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteApiKeysButton.vue?vue&type=style&index=0&id=1c7dd54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7dd54c",
  null
  
)

export default component.exports